module.exports = __webpack_public_path__ + "/images/video-explicativo-cover-vertical.cca8d17.jpg";